export default{
    data() {
    return {
      isPageShow: false
    };
  },
    methods: {
       async isExistRoute(route){
        console.log('route: ', route);
            // const menuList = this.$store.state.menues
            // const find = menuList?.find( r => r.menuUrl == route)
            // if(find){
            //     this.isPageShow = true
            //    await this.callInitialFunction()
            // }
            this.isPageShow = true
             await this.callInitialFunction()
            return true
        },
    },
}